import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import "qweather-icons/font/qweather-icons.css";

createApp(App).use(router).mount('#app')
